<template>
  <div class="editApp">
    <Modal
      title="驳回理由"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="750"
      class="editApp-modal"
    >
      <Form ref="form" :rules="ruleCustom" :model="applyDownData">
        <FormItem prop="cause" label="">
          <Input
            v-model="applyDownData.cause"
            v-textarea-filter-space
            type="textarea"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请输入驳回理由"
          >
          </Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: right">
        <Button class="btn104" shape="circle" @click="cancle">取消</Button>
        <Button
          class="btn104"
          type="primary"
          :loading="loading"
          shape="circle"
          @click="confirm"
          >提交</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { checkReturnUp, checkReturnDown } from "@/api/service";

export default {
  name: "",
  components: {},
  props: {
    form: Object,
  },
  data() {
    return {
      applyDownData: {
        id: this.form.id,
        cause: "",
      },
      loading: false,
      modalView: false,
      ruleCustom: {
        name: [
          {
            required: true,
            validator: _FORM.validate_len,
            max_len: 16,
            trigger: "blur",
            label: "应用名称",
          },
        ],
        cause: [
          {
            required: true,
            trigger: "blur",
            message: "请输入驳回理由",
          },
        ],
      },
    };
  },
  created() {
    this.modalView = true;
    console.log("接受的数据", this.form);
  },
  methods: {
    confirm() {
      this.loading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("传递的数据", this.applyDownData);
          if (this.form.status == 1) {
            checkReturnUp(this.applyDownData.id, this.applyDownData)
              .then((res) => {
                console.log("res", res);
                this.$Message.success("上架驳回成功");
                this.$router.push({ path: "/serve/servechecklist" });
              })
              .catch((err) => {
                console.log(err, "err");
              });
          }
          if (this.form.status == 5) {
            checkReturnDown(this.applyDownData.id, this.applyDownData)
              .then((res) => {
                console.log("res", res);
                this.$Message.success("下架驳回成功");
                this.$router.push({ path: "/serve/servechecklist" });
              })
              .catch((err) => {
                console.log(err, "err");
              });
          }
        } else {
          console.log("请正确填写表单信息");
          this.loading = false;
        }
      });
    },
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      this.modalView = false;
      if (!val) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.editApp-modal {
  & ::v-deep .ivu-modal-body {
    padding-bottom: 0 !important;
  }
  & ::v-deep .ivu-modal-footer {
    border-top: 0;
    padding-top: 0;
    padding-bottom: 24px;
  }
}
</style>
